// Single source of truth for the FIT FUSION ANALYTICS wordmark/logo.
// Uses the brand PNG (with transparent background) sized by height — the
// natural aspect ratio (~2.7:1) keeps the wordmark legible at every size.
//
// Heights default to a tight 28px, suitable for navbars/sidebars.
// Pass a larger height (e.g. h-12 / h-16) for login/reset hero panels.
export default function BrandMark({ className = "h-7" }) {
  return (
    <img
      src="/ffa-logo.png"
      alt="FIT FUSION ANALYTICS"
      className={`${className} w-auto select-none`}
      draggable={false}
    />
  );
}
